import app from '../angular_app.es6';
import { last } from 'lodash';

app.directive('swipePopup', ['$timeout', 'SwipePopupService', ($timeout, SwipePopupService) => {
  return {
    restrict: 'A',
    link: ($scope, $element, $attrs) => {
      let parentElement = $element.prev($attrs['swipePopup']),
          newEl = $(`<div class="${$element.attr('class')}" style="display: none"></div>`),
          cssLeft = parseInt($attrs['cssLeft'])||50,
          cssTop = parseInt($attrs['cssTop'])||-45;

      newEl.insertAfter(parentElement);
      $element.appendTo('body');

      SwipePopupService.init();

      SwipePopupService.register($element, () => {
        if (!$element) return;

        if (newEl.css('visibility') == 'hidden') {
          $element.css({
            opacity: 0,
            visibility: 'hidden'
          });
          return;
        }

        let parentOffset = parentElement.offset(),
            width = $element.width(),
            height = $element.height();

        $element.css({
          opacity: 1,
          visibility: 'visible',
          left: `${(parentOffset.left - width / 2 + cssLeft)}px`,
          top: `${(parentOffset.top - height / 2 + cssTop)}px`
        });
      });

      $scope.$on("$destroy", function() {
        if ($element) {
          SwipePopupService.unregister($element);
          $element.remove();
          $element = null;
        }
      });
    }
  };
}]);
